import { useTranslation } from 'react-i18next'

import { useScreen } from '../../../../../../hooks'
import { FormFieldSelectNG } from '../../../../../Form'
import {
  FormikField,
  getFormikFormFieldErrorProps,
} from '../../../../../Formik'
import { InputSelect } from '../../../../../Select'
import { REQUEST_WIZARD_FIELD_LINK_TYPE } from '../../../RequestWizardForm.constants'
import { Divider } from '../Divider'

import { getOptions } from './Link.utils'

function Link({ hasDivider, links }) {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen() // TODO make same by css media instead of useScreen

  const options = getOptions(links)

  return (
    <>
      {hasDivider ? <Divider /> : null}
      <FormikField
        Component={FormFieldSelectNG}
        Select={InputSelect}
        controlProps={{
          borderless: !isMobileScreenSize,
          contentProps: {
            inputProps: {
              placeholder: t('Wizard.LinksSelectPlaceholderKey'),
            },
          },
        }}
        fieldComponentProps={{
          label: t('Wizard.LinksLabelKey'),
          required: true,
          shouldAdaptToMobileScreen: true,
        }}
        getErrorProps={getFormikFormFieldErrorProps}
        name={REQUEST_WIZARD_FIELD_LINK_TYPE}
        options={options}
      />
    </>
  )
}

export default Link
